import React, {useState} from 'react';
import {connect} from "trim-redux";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {useTranslation} from "react-i18next";
import MapAddressChooserField from "./map/MapAddressChooserField";
import AddressChooserDialog from "./AddressChooserDialog";

const AddressChooserFieldHome = (props) => {
    const { t } = useTranslation();
    const [location, setLocation] = useState({});
    const [open, setOpen] = useState(false);

    const openDialog = (res) => {
        setLocation(res);
        if(!!res?.address){
            setOpen(true)
        }
    }
    return (
        <>
            <MapAddressChooserField
                clName="real-chooser home "
                setLocation={(res) => openDialog(res)} location={location}
            />
            {
                !!props.isAuth &&
                <AddressChooserDialog open={open} setOpen={setOpen} new_location={location}/>
            }
        </>
    );
};
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
});
export default withStyles(Styles)(connect(mstp)(AddressChooserFieldHome));
